/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classNames from "classnames/bind";
import styles from "./button.module.scss";
import { FC } from "react";
import loadingI from "../../assets/images/icons/loading.svg";

const cx = classNames.bind(styles);

interface ButtonProps {
  submit?: boolean;
  tabIndex?: number;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
  color?: string;
  size?: string;
  style?: Record<string, unknown>;
  leftIcon?: any;
  id?: string;

  onClick?(): void;
}

export const Button: FC<ButtonProps> = ({
  submit = false,
  tabIndex = -1,
  className = "",
  size = " ",
  color = " ",
  loading = false,
  disabled = false,
  leftIcon = null,
  style = {},
  id = "",
  onClick,
  children,
}) => {
  const styleClasses = cx("base", size, color, className.split(" "), {
    disabled: disabled || loading,
  });

  const $loader = (
    <img src={loadingI} alt="Loading" className={styles.loader} />
  );

  if (submit) {
    return loading ? (
      <div className={styleClasses} onClick={onClick} style={style} id={id}>
        {$loader}
      </div>
    ) : (
      <input
        id={id}
        type="submit"
        style={style}
        value={"" + children}
        disabled={disabled || loading}
        className={styleClasses}
        tabIndex={tabIndex}
      />
    );
  }
  return (
    <div className={styleClasses} onClick={onClick} style={style} id={id}>
      {loading ? (
        $loader
      ) : (
        <div className={styles.input}>
          {leftIcon && <div className={styles.leftIcon}>{leftIcon}</div>}
          {children}
        </div>
      )}
    </div>
  );
};

export default Button;
